import React, { useCallback, useEffect, useRef, useState } from "react";
import "./ListUsersSession.css";
import "../Dashboard.css";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import Print from "../../../components/Print";
import BaseModal from "../../../../_metronic/partials/modals/BaseModal";
import { ThemeModeComponent } from "../../../../_metronic/assets/ts/layout";
import UsersEditModal, { FormHandlesEditUsersModal } from "../../../../_metronic/partials/form/FormUsersEditModal";
import UsersAddressModal, { FormHandlesAddressModal } from "../../../../_metronic/partials/form/FormUsersAddressModal"; 

import clsx from "clsx";
import { useStyleContext } from "../../../../_metronic/helpers/StyleContext";
import ListByUserId from "../../../components/List/ListByUserId";
import { actionsInterface, columnsInterface } from "../../../../_metronic/partials/widgets";
import { useIntl } from "react-intl";
import { useAuth } from "../../../modules/auth";
import axios from "axios";
import Swal from "sweetalert2";

// 🟢 Import do Scanner e da Aba Financeira
import { ScannerQR } from "../../../../_metronic/layout/components/ScannerQR/ScannerQR";
import UserFinancialTab from "../../../../_metronic/partials/form/UserFinancialTab";

type Props = {
  users: any[];
};

const ListUsersSession: React.FC<Props> = ({ users }) => {
  const intl = useIntl();
  const pathUrl = "https://companies-admin.aacceson.com/";
  const [modalPicture, setModalPicture] = useState(false);
  const [modalAssociated, setModalAssociated] = useState(false);
  const [optionsModal, setOptionsModal] = useState<string>("associated");
  const [braceletsColors, setBraceletsColors] = useState<Array<any>>([]);
  const [overduePayments, setOverduePayments] = useState<Array<any>>([]);

  const [selectedUserIndex, setSelectedUserIndex] = useState<number | null>(null);

  const { styleState } = useStyleContext();

  const editUsersRef = useRef<FormHandlesEditUsersModal>(null);
  const editAddressRef = useRef<FormHandlesAddressModal>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  // 🟢 ESTADOS DA MODAL DE LEITURA (CÂMERA) DO QR CODE
  const [showScannerModal, setShowScannerModal] = useState<boolean>(false);
  const [cameraOn, setCameraOn] = useState<boolean>(false);
  const [isSubmittingBracelet, setIsSubmittingBracelet] = useState<boolean>(false);

  // 🟢 ESTADOS DA MODAL DE ACESSO ADMINISTRATIVO
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [adminEmail, setAdminEmail] = useState("");
  const [adminNewEmail, setAdminNewEmail] = useState(""); 
  const [adminPassword, setAdminPassword] = useState("");
  const [adminConfirmPassword, setAdminConfirmPassword] = useState("");
  const [isSubmittingAccess, setIsSubmittingAccess] = useState(false);
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);

  const { auth, currentUser } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmitForm = useCallback(() => {
    if (optionsModal === "associated") {
      editUsersRef.current?.handleSubmit();
    } else if (optionsModal === "address") {
      editAddressRef.current?.handleSubmit();
    }
  }, [optionsModal]);

  const fetchUserById = useCallback(() => {
    if (optionsModal === "associated") {
      editUsersRef.current?.fetchData();
    } else if (optionsModal === "address") {
      editAddressRef.current?.fetchData(); 
    }
  }, [optionsModal]);

  useEffect(() => {
    if (modalAssociated && (optionsModal === "associated" || optionsModal === "address")) {
      fetchUserById();
    }
  }, [modalAssociated, optionsModal, fetchUserById]);

  const openModalPicture = (index: number) => {
    setSelectedUserIndex(index);
    setModalPicture(true);
  };

  const handleCloseAssociated = () => {
    setModalAssociated(false);
    setOptionsModal("associated");
  };

  const handleOpenAssociated = (index: number) => {
    setSelectedUserIndex(index);
    setModalAssociated(true);
  };

  const closeModalPicture = () => {
    setModalPicture(false);
    setSelectedUserIndex(null);
  };

  const toggleContent = (buttonType: string) => {
    setOptionsModal(buttonType);
  };

  // 🟢 FUNÇÃO AUXILIAR PARA VALIDAR E CARREGAR A IMAGEM DE PERFIL
  const getImageUrl = (imagePath: string | null | undefined) => {
    if (!imagePath) return "/media/avatars/blank.png";
    
    // Se for Base64 ou URL externa, carrega direto
    if (imagePath.startsWith("data:image") || imagePath.startsWith("http")) {
      return imagePath;
    }
    
    // Se for arquivo do servidor, garante que não haverá barra dupla ("//")
    const cleanPath = imagePath.startsWith("/") ? imagePath.slice(1) : imagePath;
    return `${pathUrl}${cleanPath}`;
  };

  // 🟢 FUNÇÕES DA MODAL DE ACESSO
  const handleOpenAccessModal = async (item: any) => {
    const userId = item._id || item.id;
    if (!userId) return;

    setAdminEmail("");
    setAdminNewEmail(""); 
    setAdminPassword("");
    setAdminConfirmPassword("");
    setShowAccessModal(true);
    setIsLoadingEmail(true);

    try {
      const response = await axios.get(`${apiUrl}/users/${userId}`, {
        headers: { Authorization: `Bearer ${auth?.api_token}` }
      });
      const fetchedEmail = response.data?.user?.email || response.data?.email || "";
      setAdminEmail(fetchedEmail);
    } catch (error) {
      console.error("Erro ao carregar dados de acesso do usuário", error);
    } finally {
      setIsLoadingEmail(false);
    }
  };

  const handleCloseAccessModal = () => {
    setShowAccessModal(false);
    setAdminEmail("");
    setAdminNewEmail(""); 
    setAdminPassword("");
    setAdminConfirmPassword("");
  };

  const handleUpdateAccess = async (e: React.FormEvent) => {
    e.preventDefault();

    if (adminPassword && adminPassword !== adminConfirmPassword) {
      Swal.fire("Erro", "As senhas não coincidem!", "error");
      return;
    }

    let finalEmail = adminEmail;
    if (adminNewEmail.trim() !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(adminNewEmail)) {
        Swal.fire("Erro", "O novo e-mail informado não é válido!", "error");
        return;
      }
      finalEmail = adminNewEmail.trim();
    }

    if (selectedUserIndex === null) return;
    const userId = users[selectedUserIndex]._id;

    setIsSubmittingAccess(true);

    const payload: any = { email: finalEmail };
    if (adminPassword) {
      payload.password = adminPassword;
      payload.confirmPassword = adminConfirmPassword;
    }

    try {
      await axios.put(
        `${apiUrl}/users/${userId}/admin-access`,
        payload,
        { headers: { Authorization: `Bearer ${auth?.api_token}` } }
      );
      
      Swal.fire({ position: "top-end", icon: "success", title: "Acesso atualizado com sucesso!", showConfirmButton: false, timer: 1500, toast: true });
      handleCloseAccessModal();
    } catch (error: any) {
      console.error(error);
      const errorMsg = error?.response?.data?.error?.message || error?.response?.data?.message || "Erro ao atualizar acesso.";
      Swal.fire("Erro", errorMsg, "error");
    } finally {
      setIsSubmittingAccess(false);
    }
  };

  const themeColor = ThemeModeComponent.getMode() === "dark" ? "white" : "black";

  const backgroundColor = (isActive: boolean): string => {
    return themeColor === "black"
      ? isActive ? "#7E85B7" : "#B8BCDE"
      : isActive ? "#2b2b40" : "#1e1e2d";
  };

  const buttonStyle = (isActive: boolean) => ({
    color: themeColor,
    backgroundColor: backgroundColor(isActive),
    transition: "linear .15s",
  });

  const header = () => {
    const isUserAthlete = selectedUserIndex !== null && (
      users[selectedUserIndex]?._container_id === "8807d8ab4397779bf10e9f65873996ba" ||
      users[selectedUserIndex]?.roles?.some((r: any) => r?.role?._container_id === "8807d8ab4397779bf10e9f65873996ba")
    );

    return (
      <div className="d-flex justify-content-center align-items-center border-bottom p-4 gap-2">
        <p className="btn btn-sm fw-bold fs-5 w-50" style={buttonStyle(optionsModal === "associated")} onClick={() => toggleContent("associated")}>Dados Pessoais</p>
        <p className="btn btn-sm fw-bold fs-5 w-50" style={buttonStyle(optionsModal === "address")} onClick={() => toggleContent("address")}>Endereço</p>
        <p className="btn btn-sm fw-bold fs-5 w-50" style={buttonStyle(optionsModal === "financial")} onClick={() => toggleContent("financial")}>Financeiro</p>
        <p className="btn btn-sm fw-bold fs-5 w-50" style={buttonStyle(optionsModal === "bracelets")} onClick={() => toggleContent("bracelets")}>Pulseiras</p>
        <p className="btn btn-sm fw-bold fs-5 w-50" style={buttonStyle(optionsModal === "access")} onClick={() => toggleContent("access")}>Acessos</p>
        
        {isUserAthlete && (
          <p className="btn btn-sm fw-bold fs-5 w-50" style={buttonStyle(optionsModal === "athletes")} onClick={() => toggleContent("athletes")}>Atletas</p>
        )}
      </div>
    );
  };

  const footer = () => {
    return (
      <div className="d-flex justify-content-end w-100 gap-2">
        <Button
          onClick={handleSubmitForm}
          className={clsx({
            "btn-primary btn-sm": !styleState.primary_color,
            "text-hover-primary bg-hover-light": styleState.primary_color,
          })}
          style={{ backgroundColor: styleState?.primary_color, color: styleState?.primary_text_color }}
          disabled={isLoading}
        >
          {isLoading ? "" : "Salvar"}
          <span className="indicator-progress" style={{ display: isLoading ? "block" : "none" }}>
            Salvando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </Button>
      </div>
    );
  };

  const loadOverduePayments = useCallback(() => {
    axios.get(`${apiUrl}/payments/overdue-payments`, { headers: { Authorization: `Bearer ${auth?.api_token}` } })
      .then((res) => setOverduePayments(res.data)).catch(() => {});
  }, [auth?.api_token, apiUrl]);

  const loadBraceletsColors = useCallback(() => {
    axios.get(`${apiUrl}/users/bracelets-colors/${currentUser?._id_company}`, { headers: { Authorization: `Bearer ${auth?.api_token}` } })
      .then((res) => setBraceletsColors(res.data)).catch(() => {});
  }, [auth?.api_token, currentUser?._id_company, apiUrl]);

  useEffect(() => {
    loadBraceletsColors();
    loadOverduePayments();
  }, [loadBraceletsColors, loadOverduePayments]);

  const handleWhenScan = async (contentScan: string) => {
    setCameraOn(false);
    if (!contentScan || selectedUserIndex === null) {
      setShowScannerModal(false);
      return;
    }

    setIsSubmittingBracelet(true);
    try {
      const userId = users[selectedUserIndex]._id;
      await axios.post(`${apiUrl}/users/bracelets`, {
        _id_usuario: userId,
        conteudo: contentScan,
        _id_company: currentUser?._id_company
      }, {
        headers: { Authorization: `Bearer ${auth?.api_token}` }
      });
      
      Swal.fire({ position: "top-end", icon: "success", title: "Pulseira vinculada com sucesso!", showConfirmButton: false, timer: 1500, toast: true });
      setShowScannerModal(false);
    } catch (error: any) {
      const errorMsg = error.response?.data?.error || error.response?.data?.message || "Falha ao vincular a pulseira.";
      
      Swal.fire({
        title: "Erro",
        text: errorMsg,
        icon: "error",
        didOpen: () => {
          const container = Swal.getContainer();
          if (container) {
            container.style.zIndex = "2000"; 
          }
        }
      });
      setCameraOn(true);
    } finally {
      setIsSubmittingBracelet(false);
    }
  };

  const handleDeleteSingleBracelet = useCallback((item: any) => {
    const braceletId = item._id || item.id;
    if (!braceletId || selectedUserIndex === null) return;

    const userId = users[selectedUserIndex]._id;

    Swal.fire({
      title: "Excluir Pulseira?",
      text: "Deseja realmente desvincular e remover esta pulseira?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${apiUrl}/users/${userId}/bracelets/${braceletId}`, {
            headers: { Authorization: `Bearer ${auth?.api_token}` }
          });
          Swal.fire({ position: "top-end", icon: "success", title: "Pulseira excluída!", showConfirmButton: false, timer: 1500, toast: true });
        } catch (error) {
          Swal.fire("Erro", "Não foi possível excluir a pulseira.", "error");
        }
      }
    });
  }, [apiUrl, auth?.api_token, selectedUserIndex, users]);

  const columnsBracelets: columnsInterface[] = React.useMemo(() => [
    { description: "#", className: "ps-4 min-w-100px rounded-start", reference: "_id" },
    { description: "Código (QR)", className: "min-w-150px fw-bold text-primary", reference: "conteudo" },
    { description: `${intl.formatMessage({ id: "MODULE.COLUMNSINTERFACE.DESCRIPTION" })}`, className: "min-w-200px", reference: "bracelet_color_name" },
    { description: "Ativado em", className: "min-w-150px", reference: "atualizado_em", type: "date" },
    { description: `${intl.formatMessage({ id: "MODULE.COLUMNSINTERFACE.COLOR" })}`, className: "min-w-100px", reference: "bracelet_color_color", type: "color" },
    { description: "Status", className: "", reference: "status", type: "contract-status" },
    { description: `${intl.formatMessage({ id: "MODULE.COLUMNSINTERFACE.ACTIONS" })}`, className: "w-150px text-center rounded-end pe-4", reference: "actions" },
  ], [intl]);

  const actionsBracelets: actionsInterface[] = React.useMemo(() => [
    {
      url: "", 
      title: "Excluir Pulseira",
      icon: "fa-solid fa-trash text-danger fs-4", 
      type: "button", 
      action: handleDeleteSingleBracelet, 
    }
  ], [handleDeleteSingleBracelet]);

  const columnsAccess: columnsInterface[] = React.useMemo(() => [
    { description: "E-mail de Acesso", className: "min-w-250px", reference: "email" },
    { description: "Status", className: "min-w-100px", reference: "status", type: "contract-status" },
    { description: "Ações", className: "w-150px text-center", reference: "actions" },
  ], []);

  const actionsAccess: actionsInterface[] = React.useMemo(() => [
    {
      url: "#",
      icon: "/media/icons/duotune/arrows/arr076.svg",
      title: 'Acesso Administrativo',
      type: "button", 
      onClick: handleOpenAccessModal,
    }
  ], [handleOpenAccessModal]);

  return (
    <>
      <div className="card-body min-h pe-1 text-center overflow-x-scroll">
        {users.length <= 0 ? (
          <p className="text-hover-primary fs-6 m-0 text-center p-1">Nenhum usuário na seção.</p>
        ) : (
          users.map((user, indexUser) => (
            <div className="d-flex align-items-center bg-light-dark mb-1 rounded p-1" key={indexUser}>
              <span className="svg-icon svg-icon-warning" onClick={() => openModalPicture(indexUser)}>
                {/* 🟢 IMAGEM ATUALIZADA UTILIZANDO A FUNÇÃO DE VALIDAÇÃO */}
                <img
                  style={{ cursor: "pointer", border: `3px solid ${user?.bracelets?.[0]?.bracelet_color?.color || '#ccc'}`, width: "3em", height: "3em", borderRadius: "3em" }}
                  alt="users"
                  src={getImageUrl(user?.profile_image)}
                />
              </span>
              <div className="flex-grow-1 cursor-pointer">
                <p className={`${!user?.compliance || user?.overdue ? "text-danger text-hover-danger" : "text-hover-primary"} fs-6 m-0`} onClick={() => handleOpenAssociated(indexUser)}>
                  {user.first_name} {user.last_name}
                </p>
              </div>
              <div className="me-2">
                <Print
                  clientUserId={user._id}
                  clientName={`${user.first_name || ""} ${user.last_name || ""}`.trim()}
                  wristbandCodes={(user.bracelets || [])
                    .flatMap((b: { content?: string; conteudo?: string }) => [
                      b.content,
                      b.conteudo,
                    ])
                    .filter(Boolean)}
                />
              </div>
            </div>
          ))
        )}
        
        <BaseModal
          showModal={modalAssociated}
          closeModal={handleCloseAssociated}
          header={header()}
          footer={true}
          footerBody={optionsModal === "associated" || optionsModal === "address" ? footer() : null}
          centered={true}
          size="xl"
        >
          <BaseModal.Body>
            {selectedUserIndex !== null && optionsModal === "associated" && (
              <UsersEditModal setIsLoading={setIsLoading} _user_id={users[selectedUserIndex]._id} ref={editUsersRef} />
            )}
            {selectedUserIndex !== null && optionsModal === "address" && (
              <UsersAddressModal setIsLoading={setIsLoading} _user_id={users[selectedUserIndex]._id} ref={editAddressRef} />
            )}
            {selectedUserIndex !== null && optionsModal === "financial" && (
              <UserFinancialTab _user_id={users[selectedUserIndex]._id} user={users[selectedUserIndex]} />
            )}
            
            {selectedUserIndex !== null && optionsModal === "bracelets" && (
              <div className="text-center">
                <div className="d-flex justify-content-end mb-5 gap-3">
                  <button 
                    className="btn btn-primary btn-sm fw-bold" 
                    onClick={() => {
                      setShowScannerModal(true);
                      setCameraOn(true);
                    }}
                  >
                    <i className="fa-solid fa-qrcode me-2"></i> Ler QR Code da Pulseira
                  </button>
                </div>
                <ListByUserId _user_id={users[selectedUserIndex]._id} operation="bracelets" actions={actionsBracelets} columns={columnsBracelets} />
              </div>
            )}
            
            {selectedUserIndex !== null && optionsModal === "access" && (
              <div className="text-center">
                <ListByUserId _user_id={users[selectedUserIndex]._id} operation="access" actions={actionsAccess} columns={columnsAccess} />
              </div>
            )}

            {selectedUserIndex !== null && optionsModal === "athletes" && (
              users[selectedUserIndex]?._container_id === "8807d8ab4397779bf10e9f65873996ba" ||
              users[selectedUserIndex]?.roles?.some((r: any) => r?.role?._container_id === "8807d8ab4397779bf10e9f65873996ba")
            ) && (
              <div className="text-center">
                <ListByUserId _user_id={users[selectedUserIndex]._id} operation="bracelets" actions={actionsBracelets} columns={columnsBracelets} />
              </div>
            )}
          </BaseModal.Body>
        </BaseModal>

        {showAccessModal && (
          <div 
            className="modal fade show d-block" 
            tabIndex={-1} 
            role="dialog" 
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1070 }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Acesso Administrativo</h5>
                  <button 
                    type="button" 
                    className="btn-close" 
                    aria-label="Close" 
                    onClick={handleCloseAccessModal}
                  ></button>
                </div>
                
                <form onSubmit={handleUpdateAccess}>
                  <div className="modal-body text-start">
                    <div className="row">
                      <div className="col-6 mb-5 position-relative">
                        <label className="form-label fw-bold">E-mail Atual</label>
                        {isLoadingEmail ? (
                          <div className="d-flex align-items-center form-control form-control-lg bg-light">
                              <span className="spinner-border spinner-border-sm me-2 text-primary"></span>
                              Carregando...
                          </div>
                        ) : (
                          <input 
                            type="email" 
                            className="form-control form-control-lg bg-light" 
                            value={adminEmail}
                            readOnly 
                          />
                        )}
                      </div>

                      <div className="col-6 mb-5 position-relative">
                        <label className="form-label fw-bold">Novo E-mail</label>
                        <input 
                          type="email" 
                          className="form-control form-control-lg" 
                          placeholder="Deixe em branco para não alterar"
                          value={adminNewEmail}
                          onChange={(e) => setAdminNewEmail(e.target.value)}
                        />
                        <div className="form-text mt-2">
                          Preencha se desejar trocar o e-mail.
                        </div>
                      </div>

                      <div className="col-6 mb-5">
                        <label className="form-label fw-bold">Nova Senha</label>
                        <input 
                          type="password" 
                          className="form-control form-control-lg" 
                          placeholder="Deixe em branco para não alterar"
                          value={adminPassword}
                          onChange={(e) => setAdminPassword(e.target.value)}
                        />
                        <div className="form-text mt-2">
                          Preencha se desejar trocar a senha.
                        </div>
                      </div>

                      <div className="col-6 mb-5">
                        <label className="form-label fw-bold">Confirmar Nova Senha</label>
                        <input 
                          type="password" 
                          className={`form-control form-control-lg ${adminPassword && adminPassword !== adminConfirmPassword ? 'is-invalid' : ''}`} 
                          placeholder="Confirme a nova senha"
                          value={adminConfirmPassword}
                          onChange={(e) => setAdminConfirmPassword(e.target.value)}
                          disabled={!adminPassword}
                        />
                        {adminPassword && adminPassword !== adminConfirmPassword && (
                          <div className="invalid-feedback">As senhas não coincidem.</div>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-light btn-sm" 
                      onClick={handleCloseAccessModal}
                      disabled={isSubmittingAccess}
                    >
                      Cancelar
                    </button>
                    <button 
                      type="submit" 
                      className="btn btn-primary btn-sm"
                      disabled={isSubmittingAccess || (!!adminPassword && adminPassword !== adminConfirmPassword)}
                    >
                      {isSubmittingAccess ? (
                        <span className="indicator-progress d-block">
                          Salvando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        "Salvar Alterações"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        <Modal 
          show={showScannerModal} 
          onHide={() => { setShowScannerModal(false); setCameraOn(false); }} 
          centered
          style={{ zIndex: 1080 }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Vincular Pulseira via Câmera</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center position-relative">
            {isSubmittingBracelet ? (
              <div className="py-10">
                <i className="fa-solid fa-qrcode fs-3x mb-4 text-success"></i>
                <h5 className="mb-2">Salvando Pulseira...</h5>
                <span className="spinner-border text-primary mt-4"></span>
              </div>
            ) : (
              <ScannerQR contentScan={handleWhenScan} cameraOn={cameraOn} />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export { ListUsersSession };